export default {
  URLS: {
	DEPARTMENT_PAYROLL: '/payrolls/department-payroll/',
	PAYROLL: '/payrolls/',
  },
};
